import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import FoEventsForm from './FoEventForm.jsx';
import {
  useGetEventQuery,
  useGetEventsQuery,
  useSaveRestoreCopyMutation,
  useSaveEventMutation,
} from '../../../../../../redux/services/fo_events.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { Form as AntdForm } from 'antd';
import { useToastMessages } from '../../../../../../hooks/useToastMessages';

const EventsEdit = ({ mode }) => {
  const TABLE_FILTER_TITLE = 'Filter akcií';
  const { eventId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = AntdForm.useForm();

  const { saveSuccess: showSaveSuccess, errorMessage } =
    useToastMessages();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const isUnarchivation = mode === 'unarchive';

  const { data: eventDetail, isLoading } = useGetEventQuery(eventId, {
    skip: isCreate,
  });

  const [saveEvent] = useSaveEventMutation();
  const [saveRestoreCopy] = useSaveRestoreCopyMutation();

  const { refetch } = useGetEventsQuery();

  const handleSubmit = async (values) => {
    if (isUnarchivation) {
      await saveRestoreCopy({ id: eventId, body: values }).unwrap();
      localStorage.setItem(TABLE_FILTER_TITLE, 'active');
      showSaveSuccess();
      navigate(routes.cmsFoEventsList);
      refetch();
      return;
    } else {
      await saveEvent({ id: eventId, body: values }).unwrap();
    }

    showSaveSuccess();
    navigate(-1);
    refetch();
  };

  useEffect(() => {
    if (isEdit && eventDetail?.archived_at) {
      errorMessage({
        message: t('Archivovanú akciu nie je možné upravovať.'),
      });
      navigate(routes.cmsFoEventsDetail(eventId), { replace: true });
    }
  }, [eventDetail?.archived_at, eventId, errorMessage, isEdit, navigate, t]);

  const title = isCreate ? t('Pridanie akcie') : t('Úprava akcie');

  const initials = isUnarchivation
    ? {
        name: undefined,
        description: undefined,
        ...eventDetail,
        date_from: null,
        date_to: null,
      }
    : {
        name: undefined,
        description: undefined,
        date_from: undefined,
        date_to: undefined,
        ...eventDetail,
      };

  return (isEdit || isUnarchivation) && isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={title}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
        permissionsBasic={'fo-events'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('Obsah')}>
          <FoEventsForm
            initials={initials}
            onSubmit={handleSubmit}
            form={form}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default EventsEdit;
